import { TaxRateForm } from "@/features/pricing/tax-rate-form";

export function TaxRatesScreen() {
  return (
    <div className="p-4 space-y-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Tax Rates</h1>
        <p className="text-gray-600 mt-2">
          Per-province output tax EZX charges customers (EZX is the supplier of
          record, so the rate follows place-of-supply, not the carrier).
          Toggling a province inactive stops charging tax there.
        </p>
      </div>
      <TaxRateForm />
    </div>
  );
}
